import { useEffect, useState } from 'react';

export type Breakpoint = 'mobile' | 'desktop' | 'large-desktop';

const DESKTOP_BREAKPOINT = 768;
const LARGE_DESKTOP_BREAKPOINT = 1024;

export function useResponsiveBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>('mobile');

  useEffect(() => {
    const getBreakpoint = (): Breakpoint => {
      if (typeof window === 'undefined') return 'mobile';
      if (window.matchMedia(`(min-width: ${LARGE_DESKTOP_BREAKPOINT}px)`).matches) {
        return 'large-desktop';
      }
      if (window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches) {
        return 'desktop';
      }
      return 'mobile';
    };

    setBreakpoint(getBreakpoint());

    const desktopQuery = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);
    const largeQuery = window.matchMedia(`(min-width: ${LARGE_DESKTOP_BREAKPOINT}px)`);
    const handleChange = () => setBreakpoint(getBreakpoint());

    desktopQuery.addEventListener('change', handleChange);
    largeQuery.addEventListener('change', handleChange);

    return () => {
      desktopQuery.removeEventListener('change', handleChange);
      largeQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return breakpoint;
}
